import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';

import { load3DModel } from '../bboxes/bboxes.thunks';
import { exitEditor } from '../project/project.actions';
import {
  loadCloudProject,
  loadLocalProject,
  loadProject,
  refreshProjectFile,
} from '../project/project.thunks';

import { i18n } from '@nablax/i18n';
import {
  setEditingPropertyKey,
  setEditorLoading,
  toggleAnnotations,
  toggleGrid,
} from './editor-ui.actions';
import { UISliceState } from './types';

const initialState: UISliceState = {
  loading: {
    project: false,
  },
  grid: true,
  annotations: true,
  editingPropertyKey: null,
};

export const UISlice = createSlice({
  name: 'UI',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setEditingPropertyKey, (state, action) => {
      state.editingPropertyKey =
        (action.payload.propertyKey && {
          baseName: action.payload.propertyKey.split('.')[0],
          propKey: action.payload.propertyKey.split('.')[1],
        }) ||
        null;
    });
    builder.addCase(
      setEditorLoading,
      (state, action: PayloadAction<Partial<UISliceState['loading']>>) => {
        state.loading = {
          ...state.loading,
          ...action.payload,
        };
      },
    );
    builder.addCase(toggleGrid, (state) => {
      state.grid = !state.grid;
    });
    builder.addCase(toggleAnnotations, (state) => {
      state.annotations = !state.annotations;
    });
    // first loading action: loadProject
    builder.addCase(loadProject.pending, (state) => {
      state.loading.project = i18n.t('loader.project.dfiles');
    });
    // last loading project action: loadRoot3DModel
    builder.addCase(load3DModel.fulfilled, (state) => {
      state.loading.project = false;
    });
    builder.addCase(exitEditor, () => {
      return initialState;
    });
    // this redirects on error with ProjectRedirect component
    builder.addMatcher(
      isAnyOf(
        loadLocalProject.rejected,
        loadCloudProject.rejected,
        refreshProjectFile.fulfilled,
        refreshProjectFile.rejected,
      ),
      (state) => {
        state.loading.project = false;
      },
    );
  },
});

export const uiReducer = UISlice.reducer;
